<template>
  <div class="page-container">
		<HeaderLayout :pagecode="pagecode" :subpagecode="cmd" @eventProblemCode="changePage"></HeaderLayout>
		<div class="content">
	         <div class="main-1">
			      <ul>
				  	   <li class="active"  @click="hideGoodAnswerView()">{{menuText}}</li>
					   <li @click="showGoodAnswerView()">해설 보기</li>
				  </ul>
				  <div style="clear:both"></div>
			 </div>
			 
			 <div class="box-big-left">
				    <ul class="data-box">
						<li class="data-item" v-for="data,index in dataList1">
							
							<div v-if="data.bigText" class="bigTextBox">
								<div class="bigTextGuide">{{data.bigTextGuide}}</div>
								<div class="box-content" v-html="data.bigText"></div>
							</div>
							<div class="question">
								<h3 :class="data.result">
									<div class="rotate-line" v-if="data.result=='bad'"></div>
									{{((index+1)<10)?'0'+(index+1):(index+1)}}
								</h3>

								<p class="name">{{data.pbQuestion}}?</p>
							</div>
							<div class="answer-box">
								<div v-if="data.pbType=='s'" class='form-group'>
									
									<ul :class="'box-list '+data.result" >
										<li v-for="item,subIndex in data.answerList" :class="item.gclass" @click="choiceAnswer(index,subIndex)">
											<span class="text-1">{{(subIndex+1)}}</span> {{item.val}}
										</li>
									</ul>
									<div class="md-error-box">답을 입력하세요</div>
								</div>
								<div v-else  class="vAnswer">
									<div v-if="data.result" style='color:#000;font-size:14px;font-weight:bold;'>
									  {{data.uAnswer}} 
									</div>
									<div v-else class='form-group vtype'>   
										<div class="md-field">
											  <input autocomplete="off" type="text" v-model="answerList[parseInt(index)+1]" placeholder="답을 입력하세요"/>
										</div>
										<div class="md-error-box" style='margin-top:-20px;'>답을 입력하세요</div>
									</div>
								</div>
								
							</div>
						</li>
					</ul>
					<ul class="data-box">
						<li class="data-item" v-for="data,index in dataList2">
							
							<div v-if="data.bigText" class="bigTextBox">
								<div class="bigTextGuide">{{data.bigTextGuide}}</div>
								<div class="box-content" v-html="data.bigText"></div>
							</div>
							<div class="question">
								<h3 :class="data.result">
									<div class="rotate-line" v-if="data.result=='bad'"></div>
									{{((dataIndex+index+1)<10)?'0'+(dataIndex+index+1):(dataIndex+index+1)}}
								</h3>

								<p class="name">{{data.pbQuestion}}?</p>
							</div>
							<div class="answer-box">
								<div v-if="data.pbType=='s'" class='form-group'>
									
									<ul :class="'box-list '+data.result" >
										<li v-for="item,subIndex in data.answerList" :class="item.gclass" @click="choiceAnswer(dataIndex+index,subIndex)">
											<span class="text-1">{{(subIndex+1)}}</span> {{item.val}}
										</li>
									</ul>
									<div class="md-error-box">답을 입력하세요</div>
								</div>
								<div v-else  class="vAnswer">
									<div v-if="data.result" style='color:#000;font-size:14px;font-weight:bold;'>
									  {{data.uAnswer}} 
									</div>
									<div v-else class='form-group vtype'>   
										<div class="md-field">
											  <input autocomplete="off" type="text" v-model="answerList[parseInt(index)+dataIndex+1]" placeholder="답을 입력하세요"/>
										</div>
										<div class="md-error-box" style='margin-top:-20px;'>답을 입력하세요</div>
									</div>
								</div>
								
							</div>
						</li>
					</ul>
					
			</div>
			<md-button class="md-raised md-primary" @click="completeTest()" v-if="!resultFlag">완료</md-button>			 
		</div>
		<div class="screenLayout" v-if="screenView">
			<div class="content-wrapper">
				<div class="content-box">
					<ul class="search-box">
						<li><input type="text" placeholder="문제번호를 입력해주세요"  v-model="searchKey"></li>
						<li><md-button class="md-primary" @click="searchAnswerList()">바로가기</md-button></li>

					</ul>
					<ul class="data-box">
						<li class="data-item" v-for="data,index in dataList">
							
							<div class="question">
								<h3>
									{{((index+1)<10)?'0'+(index+1):(index+1)}}
								</h3>
								<div class="goodAnswername">정답 : <div class="uanswer">{{data.answerString}}</div></div>
							</div>
							<div class="bigTextBox" v-if="data.content">
								<div class="box-content" v-html="data.content"></div>
							</div>
						</li>
					</ul>
					<button class="hide-button" @click="hideGoodAnswerView()" type="button">문제로 돌아가기</button>
				</div>
			</div>
		</div>
		<FooterLayout></FooterLayout>
	</div>
</template>


<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
	name: 'AdvisorGtest',
	components: {
		HeaderLayout,
		FooterLayout
	},
	data() {
		return {
				pagecode:'advisor',
				cmd:'problem',
			  	bigTextList:[],
				dataIndex:0,
				dataList:[],
				dataList1:[],
				dataList2:[],
				answerList:{},
				resultFlag:false,
				resultTempFlag:false,
				screenView:false,
				searchKey:'',
				menuText:'내가 풀기',
				
		  }
	},
	created() {
		this.getData();
	},
    methods: {
	  getData() {
		  	var obj = this;
			this.$form.sendPost({},'problem/aiSuView',function(resp) {
				
				if(resp.result=='nodata') {
					obj.nodataView =true;
				} else if(resp.result=='succ') {
				
					if(!resp.info.no) {
						obj.$router.go(-1);
						return;
					}
					obj.no = resp.info.no;
					obj.bigTextList = []
					obj.dataList = []
					obj.answerList = {}
					obj.resultTempFlag = false;
					if(resp.resultAnswers.length>0) {
						obj.resultFlag = true;
						obj.menuText = '내가 푼 문제';
					} else if(resp.temp_resultAnswers.length>0) {
						obj.resultTempFlag = true;
						
					}
					obj.initSetting(resp);
				} else {
					alert('잘못된 접근입니다');
					obj.$router.go(-1);
					return;
				}
			},'multi');
	  
	  },
	  initSetting(resp) {
			if(resp.bigtextList.length>0) {
				for(var k in resp.bigtextList) {
					var item  = resp.bigtextList[k];
					var index = this.bigTextList.length+1;
					var item = {code:'A'+index,val:item.summary,gno:item.no,content:item.content,updcontent:item.updcontent}
					this.bigTextList.push(item)
				}
			}
			if(resp.pbList.length>0) {
				for(var k in resp.pbList) {
					var item  = resp.pbList[k];
					var temp_answer = '';
					if(item.pbType=='s') {
						var goodAnswer = '';
						for(var index in item.pbSAnswer) {
							var dataItem = item.pbSAnswer[index];
							if(this.resultFlag) {
								if((parseInt(index)+1)== parseInt(resp.resultAnswers[k].uAnswer)) {
									dataItem.gclass='active';
								} else dataItem.gclass='';
							} else if(this.resultTempFlag) {
								if((parseInt(index)+1)== parseInt(resp.temp_resultAnswers[k].uAnswer)) {
									dataItem.gclass='active';
									temp_answer = resp.temp_resultAnswers[k].uAnswer;
								} else dataItem.gclass='';
							} 
							if(parseInt(index)+1 == parseInt(item.pbAnswer)) {
								goodAnswer = '('+(parseInt(index)+1)+') '+dataItem.val;
							}
						}
						item.answerString = goodAnswer;
					} else {
						item.answerString = item.pbAnswer;
						if(this.resultTempFlag) {
							temp_answer = resp.temp_resultAnswers[k].uAnswer;
						}
					}

					if(this.resultFlag) {
						item.uAnswer = resp.resultAnswers[k].uAnswer;
						item.result = resp.resultAnswers[k].result;
					}
					item.answerList=item.pbSAnswer;
					if(this.resultTempFlag) {
						this.answerList[parseInt(k)+1] = temp_answer;
					}
					this.dataList.push(item)
				}
				this.dataReset();
			}
	  },			
	  
	  dataReset() {
			var selectedItems = {};
			for(var k in this.bigTextList) {
				var item = this.bigTextList[k];
				selectedItems[item.gno] = item.content;
			}
			
			var bigTextCode = '';
			var updateIndex = '';
			var usedBigText = {};
			for(var key in this.dataList) {
				var item = this.dataList[key];
				if(item.textRel) {
					if(bigTextCode == item.bigTextCode) {
						var startNum = parseInt(updateIndex)+1;
						var endNum = parseInt(key)+1; 
						this.dataList[updateIndex].bigTextGuide = '('+startNum+'~'+endNum+') 다음 지문을 읽고 물음에 답하시오';
						continue;
					}
					if(!usedBigText[item.bigTextCode]) {
						usedBigText[item.bigTextCode] = true;
						bigTextCode = item.bigTextCode;
						item.bigTextGuide = '다음 지문을 읽고 물음에 답하시오';
						item.bigText = selectedItems[item.bigTextCode];
						updateIndex = key;
					}
				}
			}
			bigTextCode = '';
			usedBigText = {};
			for(var k in this.dataList) {
				var item = this.dataList[k];
				
				if(k < this.dataList.length/2) {
					this.dataList1.push(this.dataList[k]);
					if(!usedBigText[item.bigTextCode]) {
						usedBigText[item.bigTextCode] = true;
						bigTextCode = item.bigTextCode;
					}
				} else {
					if(item.textRel) {
						if(bigTextCode == item.bigTextCode) {
							this.dataList1.push(this.dataList[k]);
						} else {
							this.dataList2.push(this.dataList[k]);	
						}
						
					} else {
						this.dataList2.push(this.dataList[k]);
					}
				}

			}
			this.dataIndex = this.dataList1.length;

	  },
	  choiceAnswer(index,subIndex) {
		   if(this.resultFlag)return;

			for(var key in this.dataList[index].answerList) {
				var item = this.dataList[index].answerList[key];
				if(key == subIndex) {
					item.gclass = 'active';
					
				} else {
					item.gclass = '';
					
				}
				this.$set(this.dataList[index].answerList,key,item);
			}
			//console.log(this.dataList);
			this.answerList[parseInt(index)+1] = parseInt(subIndex)+1;
			$('.form-group').eq(index).removeClass('md-invalid');

			this.$form.sendPost({answers:this.answerList,no:this.no},'problemProc/registTempTest',function(resp) {
				if(resp.result=='succ') {
					//obj.getData();	
				
				}
			});


	  },
	  completeTest() {
		var obj = this;
		var checkFlag = true;
		var top = 0;
		$('.form-group').each(function(k) {
			if(checkFlag) {
				if(!obj.answerList[parseInt(k)+1]) {
					$(this).addClass('md-invalid');
					top = $(this).offset().top -300; 
					checkFlag = false;
					return;
				}
			}
	    });
		if(!checkFlag) {
				var positionTop = top+ $('body').scrollTop();
				$('html,body').animate({
					scrollTop:positionTop
				},200);
				
			return;
		}
		var params = {
			no:this.no,
			answers:this.answerList
		}
		var obj = this;
		var alertparams = {}
		alertparams.content = '시험 문제를 제출합니다. 제출 시에는 수정이 불가능합니다.<br>시험 문제를 제출하시겠습니까?';	
		alertparams.cancleView = true;
		alertparams.doAction = function() {
			obj.$form.sendPost(params,'problemProc/registAiSuTest',function(resp) {
			if(resp.result=='succ') {
				obj.getData();	
				
			}
		});
		}
		this.$eventBus.$emit('dialogOpen',alertparams);		
		
			  
	  },
	  showGoodAnswerView() {
		 if(this.resultFlag) {
			this.searchKey = '';
			$('.main-1 ul li').removeClass('active');
			$('.main-1 ul li:last-child').addClass('active');
			 this.screenView = true;
		 
		 } else {
			var alertparams = {}
			alertparams.content = '문제를 모두 푼후에 정답을 확인하세요';	
			this.$eventBus.$emit('dialogOpen',alertparams);
		 }
	  },
	  hideGoodAnswerView() {
		 $('.main-1 ul li').removeClass('active');
		 $('.main-1 ul li:first-child').addClass('active');
		 this.screenView = false;

	  },
	  searchAnswerList() {
			if(!this.searchKey) {
				var params = {}
				params.content = '문제번호를 입력하세요';	
				this.$eventBus.$emit('dialogOpen',params);
				return;
			}
			if(!this.$form.isNumeric(this.searchKey)) {
				var params = {}
				params.content = '문제번호는 숫자만 입력가능합니다';	
				this.$eventBus.$emit('dialogOpen',params);
				return;	
			}
			var flag = false;
			var top = 0;
			var obj = this;
			$('.content-wrapper .content-box .data-item').each(function(k) {
				if(k == obj.searchKey-1) {
					flag = true;
					top = $(this).offset().top -330; 
				}

			});
			if(flag) {
				var positionTop = top + $('.content-wrapper .content-box .data-box').scrollTop();
				$('.content-wrapper .content-box .data-box').animate({
					scrollTop: positionTop
				},200);
			} else {
				var params = {}
				params.content = '문제번호가 존재하지 않습니다';	
				this.$eventBus.$emit('dialogOpen',params);
				return;	
			}
	  },
	  changePage(code) {
			switch(code) {
				case 'list':
					this.$router.push({path:'/advisor/list'});
				break;
				case 'sentence':
					this.$router.push({path:'/advisor/sentence'});
				break;
				case 'word':
					this.$router.push({path:'/advisor/word'});
				break;
				case 'problem':
					this.$router.push({path:'/advisor/gtest'});
				break;

			}
		}
	  
  },
  mounted() {
	
  },
  updated() {
	$('.form-group.vtype input').off('keyup');
	$('.form-group.vtype input').on('keyup',function() {
		
		if($(this).val()) {
			$(this).parent().parent().removeClass('md-invalid');
		}
		
	});
	$('.content-wrapper .content-box').css({'max-height':($(window).height()-160)+'px'});
	
  }

}
</script>

<style lang="scss" scoped>

.md-field {
	input[type="text"] {
		border:none;
		background:#fff;
		border-bottom:solid 1px #ccc;
		width:80%;
		&:focus {
			outline:none;
			border-bottom:solid 1px #222;
		}
	}	
}
.page-container {
	width:calc(100vw);
	min-height:calc(100vh);
	background:#E6E8F4;
	
	.data-box {
			&:first-child {
				border-right:solid 1px #ccc;
			}
			width:400px;
			padding:20px 40px 0 40px;
			li.data-item {
				padding-bottom:20px;
				font-family: 'Nanum Gothic', sans-serif;
				  h3   {
				  		margin-top:10px;
						font-size:18px;
						color:#3D79FF;
				  }
				  h3.good {
						border:solid 1px #F24A4A;
						width:30px;
						height:30px;
						border-radius:15px;
						padding-top:5px;
						text-align:center;
				  }
				   h3.bad {
				   		position:relative;
						.rotate-line {
							top:-12px;
							left:-15px;
							position:absolute;
							width:30px;
							height:30px;
							border-top:1px solid #F24A4A;
							transform:rotate(130deg);
							-ms-transform:rotate(130deg);
							-webkit-transform:rotate(130deg);
							-moz-transform:rotate(130deg);
							-o-transform:rotate(130deg);
						}
				  }
				  &first-child {
					 h3   {
				  		padding-top:0;
					}
				  	
				  }
				  .name      {
				        font-size:13px;
						color:#000;
						padding-top:4px;
						font-weight:bold;
				  }
				  .bigTextGuide {
					color:#000;
					font-weight:bold;
					font-size:13px;
					padding-bottom:10px;
				  }
				  .box-content        {
				  		border:4px solid #9AB4EE;
						background:#F4F4F4;
						padding:13px 12px;
						font-size:11px;
						word-spacing:-2px;
				  }
				  .box-list        {
				        padding-top:3px;
						margin-bottom:10px;
					    li        {
						  width:100%;
						  margin-top:6px;
						  cursor:pointer;
						  font-size:12px;
						  .text-1      {
								  		   display:inline-block;
										   width:15px;
										   height:15px;
										   border:1px solid #ABABAB;
										   text-align:center;
										   line-height:13px;
										   border-radius:50%;
										   margin-right:3px;
								  }
						}
						li.active    {
							color:#F24A4A;
							.text-1     {
								  border:1px solid #F24A4A;
							}
						}
				  }
				  .box-list.bad  {
				       li  {
							cursor:default;	
					   }
				  }
				  .box-list.good  {
				       li  {
							cursor:default;	
					   }
				  }
			}
		}	
	.content{       
		width:800px;
		height:auto;
		margin:auto;
		overflow-x:hidden;
		padding:160px 0 50px 0;
		font-family: 'Nanum Gothic', sans-serif;
		z-index:10000;
		height:auto;
		.box-big-left {
			background-color:#fff;
			display:flex;
			padding:30px 0;
		}
		.md-button {
				padding:0;
				margin:0;
				width:100%;
		}
		.main-1      {
		      padding:12px 0 15px 0;
			  	 ul     {
				      li     {
					      font-size:13px;
						  color:#A0A0A0;
						  width:47%;
						  padding:7px 0;
						  cursor:pointer;
						  text-align:center;
						  border-radius:20px;
						  background:#fff;
						  border:1px solid #C7C7C7;
						  color:#C7C7C7;
						  &:last-child     {
						         float:right;
						 }
						  &:first-child     {
						         float:left; 
								 
						  }
					  }
					  li.active {
							background:#3D79FF;
							color:#fff;
						  
						  
					  }
				  }
		}
	}
	.screenLayout {
		.content-wrapper {
			.content-box {
				border-radius:0;
				width:400px;
				margin:80px auto;
				padding:0;
				.search-box {
					padding:15px 20px 0 20px;
					display:flex;
					li:first-child {
						width:300px;
						input {
							width:100%;
							height:40px;
							padding:0 10px;
							border:solid 1px #dfdfdf;
						}
					}
					li:last-child {
						width:100px;
						.md-button {
							width:100%;
							margin:0;
							height:40px;
							background:#448AFF;
							color:#fff;
						}
					}
				}
				.data-box {
					padding:20px 20px 50px 20px;
					height:450px;
					overflow-y:auto;
					text-align:left;
					li.data-item {
						text-align:left;
						.goodAnswername {
							padding:5px 0 8px 0;
							font-size:11pt;
							font-weight:bold;
							color:#000;
							.uanswer {
								color:#F24A4A;
								display:inline-block;
							}
						}
						.box-content {
							font-size:9pt;
						}

					}
				}
				.hide-button { 
					background:#515F83;
					width:100%;
					height:45px;
					line-height:45px;
					color:#fff;
					text-align:center;
					border:none;
					cursor:pointer;
				}
			}
		}
	}
}
</style>